// DevHub UI kit — error state block.
//
// The tinted error panel every section re-invents. Title/message defaults are i18n'd.
import { useTranslationRef } from '@backstage/core-plugin-api/alpha';
import { kitMessages } from '../../../i18n/kit';
import './states.css';

export interface ErrorStateProps {
  /** The error message to display. */
  message?: string;
}

export const ErrorState = ({ message }: ErrorStateProps) => {
  const { t } = useTranslationRef(kitMessages);
  return (
    <div className="devhub-state devhub-state--error" role="alert">
      <odx-icon name="core::warning" size="lg" />
      <h3 className="devhub-state__title">{t('states.errorTitle')}</h3>
      {message && <p className="devhub-state__message">{message}</p>}
    </div>
  );
};
